<template>
    <div>
        <div style="position: relative">
            <b-spinner v-if="loading" variant="primary"
                style="position: absolute;bottom:3px;right:20px;z-index: 999"></b-spinner>
            <l-map style="height: 92vh" :zoom="zoom" :center="center" ref="myMap" :options="{
                zoomControl: false,
                maxZoom: 18,
                attributionControl: false
            }">
                <l-control-zoom position="topright" :options="zoomOption" />
                <l-control position="topright">
                    <div class="leaflet-bar">
                        <a @click="refreshMapView" title="Xem toàn cảnh" role="button" aria-label="Xem toàn cảnh"><i
                                class="fa fa-arrows-alt fa-lg" /></a>
                        <a @click="refreshMap" title="Làm mới bản đồ" role="button" aria-label="Làm mới bản đồ"><i
                                class="fa fa-refresh fa-lg" /></a>
                    </div>
                </l-control>
                <div>
                    <l-marker :lat-lng="[item.lat, item.long]" @click="openLayerModal(item)"
                        v-if="!listGeoPoint.includes(item)" v-for="item in listLayerPoint" :key="item.id"
                        ref="pointMarkers" :options="{ pointId: item.id }">
                        <l-tooltip>{{ item.name }}</l-tooltip>
                        <l-icon>
                            <div class="station-bg" :style="{
                                backgroundColor: getMarkerColor1(item)
                            }">
                                <div class="font-weight-bold" :style="{
                                    backgroundColor: getMarkerColor2(item)
                                }">
                                    <span>{{ formatNumber(item?.data?.value) }}</span>
                                </div>
                            </div>
                        </l-icon>
                    </l-marker>
                </div>
                <div>
                    <l-marker :lat-lng="[item.lat, item.long]" v-for="item in listLayerPhoto" :key="item.id">
                        <l-tooltip>{{ item.description }}</l-tooltip>
                        <l-icon>
                            <img :src="getPhotoIcon(item)" :width="item.layer?.iconSize ?? 20"
                                :height="item.layer?.iconSize ?? 20" />
                        </l-icon>
                        <l-popup>
                            <b-carousel controls img-width="200" style="min-width: 200px;">
                                <b-carousel-slide v-for="path in item.images" :key="path">
                                    <template #img>
                                        <img v-if="isImage(path)" class="d-block img-fluid w-100" width="200"
                                            :src="API_CONFIG.BASE_URL + 'download?fileName=' + path" />
                                        <video v-else class="d-block img-fluid w-100" width="200" controls
                                            :src="API_CONFIG.BASE_URL + 'download?fileName=' + path"></video>
                                    </template>
                                </b-carousel-slide>
                            </b-carousel>
                            <p>{{ item.description }}</p>
                        </l-popup>
                    </l-marker>
                </div>
                <l-control position="topleft">
                    <div class="leaflet-bar">
                        <a @click="openUploadImageModal" title="Chụp ảnh" role="button" aria-label="Chụp ảnh"><i
                                class="fa fa-camera" /></a>
                    </div>
                </l-control>
            </l-map>
            <TifLegendInfo style="position: absolute; width: 100%; z-index: 999"
                :style="{ bottom: rasterInfo?.files.length > 1 ? '30px' : '10px' }"
                v-if="showLegend && lastLayerSelected?.dataType === 'raster'" :title="rasterInfo.name"
                :legend="rasterInfo.legend" />
            <TifLegendInfo style="position: absolute; width: 100%; z-index: 999"
                :style="{ bottom: rasterInfo?.files.length > 1 ? '30px' : '10px' }"
                v-if="showLegend && geoInfo && lastLayerSelected?.dataType === 'geojson'" :title="geoInfo.name"
                :legend="geoInfo.legend" />
            <Timeline v-if="rasterInfo?.files.length > 1"
                style="position: absolute; width: 100%; bottom: -15px; z-index: 999" :files="rasterInfo?.files"
                @time-change="onTimeChange" />
            <div style="position: absolute;top: 0px;left: 0px;z-index: 1000;height: 100%" ref="leftSidePanel">
                <div style="position: relative;height: 100%">
                    <div :style="{ display: showLeftSide ? 'block' : 'none' }"
                        style="width: 300px;background-color: #fff;height: 100%" class="pt-2 px-3">
                        <b-checkbox v-model="showLabel" size="sm">Hiển thị nhãn</b-checkbox>
                        <b-checkbox v-model="showLegend" size="sm">Hiển thị bảng chú giải</b-checkbox>
                        <b-checkbox v-model="showPointList" size="sm">Hiển thị danh sách điểm</b-checkbox>
                        <div class="my-1">Bản đồ nền ( <i class="fa fa-map"></i> ):</div>
                        <treeselect :searchable="false" class="summary-treeselect" :options="listBaseMap"
                            :normalizer="normalizer" v-model="selectedBaseMap" :disable-branch-nodes="true"
                            style="z-index: 1000;" multiple valueFormat="object" :placeholder="baseMapPlaceholder" />
                        <div class="my-1 mt-4">Lớp dữ liệu ( <i class="fa fa-map-o"></i> ):</div>
                        <treeselect :searchable="false" class="mb-4 summary-treeselect" always-open
                            :normalizer="normalizer" :options="listLayerMap" v-model="selectedLayerMap"
                            :disable-branch-nodes="true" multiple valueFormat="object"
                            :placeholder="layerMapPlaceholder" />
                    </div>
                    <b-button variant="primary"
                        style="position: absolute;right: -17px;top: 50%;padding-left: 5px;padding-right: 5px;"
                        @click="showLeftSide = !showLeftSide"><i
                            :class="`fa fa-caret-${showLeftSide ? 'left' : 'right'}`" aria-hidden="true"></i></b-button>
                </div>
            </div>
            <div v-if="showPointList" class="point-list-panel" :style="{ bottom: pointListBottom }">
                <div class="point-list-header">
                    <div class="point-list-title">
                        <i class="fa fa-list-ul mr-1"></i>
                        Danh sách điểm
                    </div>
                    <div class="point-list-count">{{ listLayerPoint.length }}</div>
                </div>
                <div class="point-list-table-wrap">
                    <table class="table table-sm mb-0 point-list-table">
                        <thead>
                            <tr>
                                <th>STT</th>
                                <th>Tên điểm</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in listLayerPoint" :key="item.id"
                                :class="['point-list-row', { active: selectedPoint?.id === item.id }]"
                                @click="openPointFromList(item)">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.name }}</td>
                            </tr>
                            <tr v-if="listLayerPoint.length === 0">
                                <td colspan="2" class="text-center text-muted py-3">Không có điểm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <b-modal v-model="showDataModal" hide-header hide-footer centered size="lg" modal-class="station-modal">
            <Statistic :point="selectedPoint" />
        </b-modal>

        <b-modal v-model="showLayerModal" hide-header hide-footer centered size="lg" modal-class="station-modal">
            <StatisticCompare :point="selectedPoint" :listLayerPoint="listLayerPoint" />
        </b-modal>
        <b-modal v-model="showRasterDetailModal" hide-header hide-footer centered size="lg" modal-class="station-modal">
            <RasterPointDetail v-if="selectedPointDetail" :point-detail="selectedPointDetail" />
        </b-modal>
        <b-modal title="Đăng ảnh, video" no-close-on-esc no-close-on-backdrop v-model="showModalPhoto">
            <b-form-group label="Vĩ độ">
                <b-form-input v-model="form.lat" v-validate="'required'" placeholder="Vĩ độ" name="lat" type="number"
                    data-vv-as="Vĩ độ"></b-form-input>
                <div v-show="errors.has('lat')" class="validation-message text-danger">
                    {{ errors.first('lat') }}
                </div>
            </b-form-group>
            <b-form-group label="Kinh độ">
                <b-form-input v-model="form.long" v-validate="'required'" placeholder="Kinh độ" type="number"
                    name="long" data-vv-as="Kinh độ"></b-form-input>
                <div v-show="errors.has('long')" class="validation-message text-danger">
                    {{ errors.first('long') }}
                </div>
            </b-form-group>
            <b-form-group label="Mô tả">
                <b-form-textarea v-model="form.description" rows="3" placeholder="Nhập thông tin" />
            </b-form-group>
            <b-form-group label="Liên kết tới lớp dữ liệu">
                <treeselect :searchable="false" :options="listLayerMap" :normalizer="normalizer" v-model="form.layerId"
                    placeholder="Chọn lớp dữ liệu" />
            </b-form-group>
            <b-form-group label="Hình ảnh, video">
                <b-form-file v-model="listFile" accept="image/*,video/*" capture v-validate="'required'" multiple
                    name="listFile" placeholder="Chưa có ảnh, video nào được chọn" browse-text="Chụp"
                    data-vv-as="Hình ảnh, video" />
                <div v-show="errors.has('listFile')" class="validation-message text-danger">
                    {{ errors.first('listFile') }}
                </div>
            </b-form-group>
            <template #modal-footer>
                <b-button variant="secondary" @click="showModalPhoto = false">
                    {{ $t('common.cancel') }}
                </b-button>
                <b-button variant="primary" @click="updateLocate" :disabled="loading">
                    <b-spinner v-if="loading" small /> Thêm
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import API_CONFIG from '@/api-config';
import Statistic from '@/components/StatisticUser';
import StatisticCompare from '@/components/StatisticCompareUser';
import RasterPointDetail from '@/components/RasterPointDetail';
import TifLegendInfo from '@/components/TifLegendInfo';
import GeoLegendInfo from '@/components/GeoLegendInfo';
import Timeline from '@/components/Timeline';
import CONSTANTS from '@/constants';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import parseGeoraster from '@quanghd96/georaster';
import GeoRasterLayer from '@quanghd96/georaster-layer-for-leaflet';

const DISPLAY_OPTIONS_STORAGE_KEY = 'map_display_options';

export default {
    props: {
        type: {
            type: String,
            options: ['Nước mặt', 'Nước dưới đất']
        },
        configKey: {
            type: String,
            default: ''
        }
    },
    components: {
        Statistic,
        Treeselect,
        StatisticCompare,
        RasterPointDetail,
        TifLegendInfo,
        GeoLegendInfo,
        Timeline
    },
    data() {
        return {
            zoom: 6,
            center: [16.047079, 106.20623],
            zoomOption: {
                zoomInTitle: 'Phóng to',
                zoomOutTitle: 'Thu nhỏ'
            },
            showDataModal: false,
            showLayerModal: false,
            selectedBaseMap: [],
            listBaseMap: [],
            selectedLayerMap: [],
            listLayerMap: [],
            listLayerActive: {},
            listPoint: [],
            listDataPoint: [],
            listLayerPoint: [],
            listPhoto: [],
            listLayerPhoto: [],
            selectedPoint: {},
            rasterLayer: null,
            rasterInfo: null,
            geoInfo: null,
            API_CONFIG,
            showLabel: false,
            listGeoPoint: [],
            mapGeoPoint: {},
            loading: false,
            showModalPhoto: false,
            form: {},
            listFile: [],
            showLeftSide: false,
            showLegend: true,
            showPointList: false,
            listSelectedId: [],
            lastLayerSelected: null,
            showRasterDetailModal: false,
            selectedPointDetail: null
        };
    },
    async mounted() {
        await this.$nextTick();
        this.loadDisplayOptions();
        this.initMapControl();

        const map = this.$refs.myMap.mapObject;
        map.on('click', this.handleMapClickRaster);

        const [listBaseMap, listLayerMap, defaultView] = await Promise.all([
            this.getLayerTree({ type: 'base' }),
            this.getLayerTree({ type: 'layer' }),
            this.configKey ? this.getMapView(this.configKey) : null
        ]);
        if (defaultView) {
            this.center = defaultView.center;
            this.zoom = defaultView.zoom;
            await this.$nextTick();
            this.refreshMapView();
        }
        this.listBaseMap = listBaseMap;
        this.listLayerMap = this.filterLayerTreeByMapShow(listLayerMap);

        const [listPoint, listPhoto] = await Promise.all([
            this.getListPoint(),
            this.getListPhoto()
        ]);
        this.listPoint = Array.isArray(listPoint) ? listPoint : [];
        this.listDataPoint = this.listPoint.filter(item => !item.layerId);
        this.listPhoto = Array.isArray(listPhoto) ? listPhoto : [];

        const subGroup = {};

        for (const item of this.listDataPoint) {
            const groupKey = item.lat + '-' + item.long;
            if (!subGroup[groupKey]) {
                const parentGroup = L.markerClusterGroup({
                    iconCreateFunction: cluster => {
                        return L.divIcon({
                            html: `<div class="station-bg" style="background-color: ${this.getMarkerColor1(
                                item
                            )}">
                        <div class="font-weight-bold" style="background-color: ${this.getMarkerColor2(
                                item
                            )}">
                            <span>${item?.data?.value}</span></div></div>`
                        });
                    }
                });
                parentGroup.addTo(map);
                const mySubGroup = L.featureGroup.subGroup(parentGroup);
                subGroup[groupKey] = mySubGroup;
                mySubGroup.addTo(map);
            }
            const mySubGroup = subGroup[groupKey];
            const marker = L.marker([item.lat, item.long], {
                icon: L.divIcon({
                    html: `<div class="station-bg" style="background-color: ${this.getMarkerColor1(
                        item
                    )}">
                        <div class="font-weight-bold" style="background-color: ${this.getMarkerColor2(
                        item
                    )}">
                            <span>${item?.data?.value}</span></div></div>`
                })
            });
            marker
                .addTo(mySubGroup)
                .bindTooltip(item.name)
                .on('click', () => {
                    this.openDataModal(item);
                });
        }
        this.selectedBaseMap = this.getDefaultLayer(this.listBaseMap);
        this.selectedLayerMap = this.getDefaultLayer(this.listLayerMap);
        document.addEventListener('click', this.handleClickOutside);

    },
    beforeDestroy() {
        const map = this.$refs.myMap?.mapObject;
        if (map) {
            map.off('click', this.handleMapClickRaster);
        }
        document.removeEventListener('click', this.handleClickOutside);
    },
    watch: {
        selectedBaseMap(newValue, oldValue) {
            this.updateLayer(newValue, oldValue);
        },
        selectedLayerMap(newValue, oldValue) {
            this.listSelectedId = newValue.map(item => item.id);
            this.listLayerPoint = this.listPoint.filter(item =>
                this.listSelectedId.includes(item.layerId)
            );
            this.listLayerPhoto = this.listPhoto.filter(item =>
                this.listSelectedId.includes(item.layerId)
            );
            this.updateLayer(newValue, oldValue);
        },
        showLabel(value) {
            for (const id of Object.keys(this.listLayerActive)) {
                for (const layer of this.listLayerActive[id]) {
                    if (layer instanceof L.GeoJSON) {
                        layer.eachLayer(item => {
                            if (item instanceof L.Marker) {
                                const tooltip = item.getTooltip();
                                if (!tooltip) return;
                                item.unbindTooltip();
                                item.bindTooltip(tooltip.getContent(), {
                                    permanent: value,
                                    direction: 'right',
                                    className: 'point-label'
                                });
                            }
                        });
                    }
                }
            }
            this.saveDisplayOptions();
        },
        showLegend() {
            this.saveDisplayOptions();
        },
        showPointList() {
            this.saveDisplayOptions();
        }
    },
    computed: {
        baseMapPlaceholder() {
            const count = this.selectedBaseMap?.length ?? 0;
            if (count === 0) return 'Chọn bản đồ nền';
            return `${count} bản đồ nền`;
        },
        layerMapPlaceholder() {
            const count = this.selectedLayerMap?.length ?? 0;
            if (count === 0) return 'Chọn lớp dữ liệu';
            return `${count} lớp dữ liệu`;
        },
        pointListBottom() {
            if (this.rasterInfo?.files?.length > 1) return '45px';
            return '10px';
        }
    },
    methods: {
        ...mapActions({
            getListPoint: 'point/getList',
            getListPhoto: 'photo/getList',
            getLayerTree: 'mapLayer/getListTree',
            downloadLayerFile: 'mapLayer/downloadFile',
            upload: 'file/upload',
            createPhotoPoint: 'photo/create',
            getMapView: 'config/getMapView'
        }),
        loadDisplayOptions() {
            try {
                const saved = localStorage.getItem(DISPLAY_OPTIONS_STORAGE_KEY);
                if (!saved) return;
                const options = JSON.parse(saved);
                if (typeof options.showLabel === 'boolean') this.showLabel = options.showLabel;
                if (typeof options.showLegend === 'boolean') this.showLegend = options.showLegend;
                if (typeof options.showPointList === 'boolean')
                    this.showPointList = options.showPointList;
            } catch (error) { }
        },
        saveDisplayOptions() {
            try {
                const options = {
                    showLabel: this.showLabel,
                    showLegend: this.showLegend,
                    showPointList: this.showPointList
                };
                localStorage.setItem(DISPLAY_OPTIONS_STORAGE_KEY, JSON.stringify(options));
            } catch (error) { }
        },
        initMapControl() {
            const map = this.$refs.myMap.mapObject;

            const measureControl = new L.Control.Measure({
                position: 'topright',
                activeColor: 'blue',
                completedColor: 'red',
                primaryLengthUnit: 'kilometers',
                secondaryLengthUnit: undefined,
                primaryAreaUnit: 'hectares',
                secondaryAreaUnit: undefined
            });
            measureControl.addTo(map);

            L.control
                .locate({
                    strings: {
                        title: 'Hiển thị vị trí hiện tại',
                        popup: 'Bạn cách vị trí hiện tại {distance} mét'
                    },
                    position: 'topright',
                    onLocationError: e => {
                        this.$toaster.error('Không thể lấy thông tin vị trí hiện tại');
                    }
                })
                .addTo(map);

            const editableLayers = new L.FeatureGroup();
            map.addLayer(editableLayers);

            const baseMap = {};

            for (const option of CONSTANTS.BASE_MAP_OPTIONS) {
                const layerOptions = { maxZoom: 20 };
                if (option.subdomains) layerOptions.subdomains = option.subdomains;
                const layer = L.tileLayer(option.url, layerOptions);
                baseMap[option.label] = layer;
            }
            Object.values(baseMap)[0].addTo(map);

            L.control
                .layers(baseMap, null, {
                    position: 'bottomleft'
                })
                .addTo(map);
        },
        async openDataModal(data) {
            this.selectedPoint = data;
            this.showDataModal = true;
        },
        async openLayerModal(data) {
            this.selectedPoint = data;
            this.showLayerModal = true;
        },
        refreshMapView() {
            this.$refs.myMap.mapObject.setView(this.center, this.zoom);
        },
        refreshMap() {
            this.$refs.myMap.mapObject.eachLayer(layer => {
                if (
                    layer instanceof L.Circle ||
                    layer instanceof L.Rectangle ||
                    layer instanceof L.Path ||
                    layer instanceof L.Polygon
                ) {
                    this.$refs.myMap.mapObject.removeLayer(layer);
                }
            });
            this.refreshMapView();
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name,
                children: node.children
            };
        },
        nodeMatchesMapType(node) {
            if (!this.type) return true;
            if (!Array.isArray(node?.mapShow)) return false;
            return node.mapShow.includes(this.type);
        },
        filterLayerTreeByMapShow(nodes = []) {
            return (nodes || [])
                .filter(node => this.nodeMatchesMapType(node))
                .map(node => {
                    if (!Array.isArray(node.children)) return node;
                    const filteredChildren = this.filterLayerTreeByMapShow(node.children);
                    if (filteredChildren.length === node.children.length) return node;
                    return {
                        ...node,
                        children: filteredChildren
                    };
                });
        },
        async updateLayer(newValue, oldValue) {
            this.lastLayerSelected = newValue.findLast(item => item.dataType);
            this.loading = true;
            const map = this.$refs.myMap.mapObject;
            const listRemoved = (oldValue ?? []).filter(item => !(newValue ?? []).includes(item));
            for (const it of listRemoved) {
                const id = it.id;
                delete this.mapGeoPoint[id];
                for (const item of this.listLayerActive[id] ?? []) {
                    map.removeLayer(item);
                }
                if (this.rasterInfo && this.rasterInfo.id === id) {
                    map.removeLayer(this.rasterLayer);
                    this.rasterLayer = null;
                    this.rasterInfo = null;
                    this.showRasterDetailModal = false;
                    this.selectedPointDetail = null;
                }
                if (this.geoInfo && this.geoInfo.id === id) {
                    this.geoInfo = null;
                }
            }

            const listAdded = (newValue ?? []).filter(item => !(oldValue ?? []).includes(item));
            const rasterInfo = listAdded.findLast(item => item.dataType === 'raster');
            if (rasterInfo) {
                this.rasterInfo = rasterInfo;
                const file = this.rasterInfo.files?.[0];
                if (file) {
                    await this.upsertRasterLayer(file);
                }
            }

            for (const it of listAdded) {
                const id = it.id;
                this.listLayerActive[id] = [];
                if (it.dataType != 'geojson') continue;
                for (const fileName of it.files) {
                    try {
                        const legend = it.legend ?? [];
                        const content = await this.downloadLayerFile({ id, fileName });
                        if (content.features.length === 0) continue;
                        const key = Object.keys(content.features[0].properties)[1];
                        this.geoInfo = {
                            id,
                            fileName,
                            name: it.name,
                            type: it.type,
                            legend
                        };
                        this.mapGeoPoint[id] = [];
                        for (const feature of content.features) {
                            if (feature.geometry.type === 'Point') {
                                const lat = feature.geometry.coordinates[1];
                                const long = feature.geometry.coordinates[0];
                                const point = this.listPoint.find(
                                    item => (item.lat - lat) ** 2 + (item.long - long) ** 2 < 0.01
                                );
                                if (point) this.mapGeoPoint[id].push(point);
                            }
                        }
                        this.listGeoPoint = Object.values(this.mapGeoPoint).flat();
                        const getFeatureStyle = feature => {
                            if (legend.length === 0) {
                                let color = feature.properties?._mapColor;
                                if (!color) {
                                    color = '#' + Math.floor(Math.random() * 16777215).toString(16);
                                    if (feature.properties) feature.properties._mapColor = color;
                                }
                                return { weight: 0.5, color, fillColor: color, fillOpacity: 0.2 };
                            }

                            const value = feature.properties[key];
                            for (const item of legend) {
                                if (value <= item.value) {
                                    return {
                                        weight: 0.5,
                                        color: item.color,
                                        fillColor: item.color,
                                        fillOpacity: 0.2
                                    };
                                }
                            }
                            return { weight: 0.5, color: '#000', fillColor: '#000', fillOpacity: 0.2 };
                        };
                        const layer = L.geoJSON(content, {
                            style: feature => getFeatureStyle(feature),
                            pointToLayer: (feature, latlng) => {
                                const label = `${Object.values(feature.properties)[0]}`;
                                const iconSize = it.iconSize ?? 20;
                                let iconUrl = '/img/add.png';
                                if (it.pointIcon) {
                                    iconUrl =
                                        API_CONFIG.BASE_URL + 'download?fileName=' + it.pointIcon;
                                }
                                return L.marker(latlng, {
                                    icon: L.icon({
                                        iconUrl,
                                        iconSize: [iconSize, iconSize]
                                    })
                                }).bindTooltip(label, {
                                    permanent: this.showLabel,
                                    direction: 'right',
                                    className: 'point-label'
                                });
                            },
                            onEachFeature: (feature, layer) => {
                                const geometryType = feature.geometry?.type ?? '';
                                if (geometryType.includes('Polygon')) {
                                    const defaultStyle = getFeatureStyle(feature);
                                    const highlightStyle = {
                                        ...defaultStyle,
                                        weight: Math.max((defaultStyle.weight ?? 1) + 1, 2),
                                        fillOpacity: 0.45
                                    };

                                    layer.on('mouseover', () => {
                                        layer.setStyle(highlightStyle);
                                        layer.bringToFront();
                                    });
                                    layer.on('mouseout', () => {
                                        layer.setStyle(defaultStyle);
                                    });
                                }

                                if (feature.properties) {
                                    let body = '';
                                    for (const key in feature.properties) {
                                        body += `<tr><td style="font-weight: bold">${key}</td><td>${feature.properties[key]}</td></tr>`;
                                    }
                                    let popupContent = `<table class="geojson-table table-striped table-bordered">${body}</table>`;
                                    const popupContentElement = document.createElement('div');
                                    popupContentElement.innerHTML = popupContent;
                                    const button = document.createElement('button');
                                    button.className = 'btn btn-primary btn-sm mt-2';
                                    button.innerText = 'Xem dữ liệu';
                                    layer.bindPopup(popupContentElement);

                                    layer.on('popupopen', () => {
                                        let point;
                                        if (geometryType.includes('Point')) {
                                            const [long, lat] = feature.geometry.coordinates;
                                            point = this.listGeoPoint.find(
                                                item => (item.lat - lat) ** 2 + (item.long - long) ** 2 < 0.01
                                            );
                                        }
                                        if (geometryType.includes('Polygon')) {
                                            point = this.listLayerPoint.find(
                                                item => item.name == feature.properties["Ten"]
                                            );
                                        }
                                        if (point) {
                                            button.onclick = () => {
                                                this.selectedPoint = point;
                                                if (point.layerId) {
                                                    this.openLayerModal(this.selectedPoint);
                                                } else this.openDataModal(this.selectedPoint);
                                            };
                                            popupContentElement.appendChild(button);
                                        } else {
                                            button.remove();
                                        }
                                    });
                                }
                            }
                        });
                        this.listLayerActive[id].push(layer);
                        layer.addTo(map);
                    } catch (error) { }
                }
            }
            this.listGeoPoint = Object.values(this.mapGeoPoint).flat();
            this.loading = false;
        },
        isImage(url) {
            return url.match(/\.(jpeg|jpg|gif|png|svg|webp|bmp|ico|tiff|tif|raw|heif|heic)$/);
        },
        getMarkerColor1(item) {
            if (!item.data) return '#00800080';
            for (const it of item.legend ?? []) {
                if (item.data.value <= it.value) {
                    return it.color + '80';
                }
            }
            if (item.legend && item.legend.length > 0) {
                const lastColor = item.legend[item.legend.length - 1].color;
                return lastColor + '80';
            }
            return '#00800080';
        },
        getMarkerColor2(item) {
            if (!item.data) return '#008000';
            for (const it of item.legend ?? []) {
                if (item.data.value <= it.value) return it.color;
            }
            if (item.legend && item.legend.length > 0) {
                const lastColor = item.legend[item.legend.length - 1].color;
                return lastColor;
            }
            return '#008000';
        },
        openUploadImageModal() {
            this.showModalPhoto = true;
            this.form = {};
            this.listFile = [];
            this.setCurrentLocation();
        },
        async updateLocate(modal) {
            modal.preventDefault();
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.loading = true;
            for (const file of this.listFile) {
                const data = await this.upload({ formData: { file } });
                this.form.images = this.form.images || [];
                this.form.images.push(data.path);
            }
            await this.createPhotoPoint(this.form);
            this.showModalPhoto = false;
            this.listPhoto = await this.getListPhoto();
            this.listLayerPhoto = this.listPhoto.filter(item =>
                this.listSelectedId.includes(item.layerId)
            );
            this.$toaster.success('Thành công');
            this.loading = false;
        },
        setCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showPosition);
            } else {
                this.$toaster.error('Không thể lấy thông tin vị trí hiện tại');
            }
        },
        async showPosition(position) {
            this.form = {
                lat: position.coords.latitude.toFixed(4),
                long: position.coords.longitude.toFixed(4)
            };
        },
        getPhotoIcon(item) {
            if (!item.layer?.pointIcon) return '/img/image.png';
            return API_CONFIG.BASE_URL + 'download?fileName=' + item.layer.pointIcon;
        },
        formatNumber(value) {
            if (value == null) return '';
            if (value % 1 === 0) return value;
            return value.toFixed(1);
        },
        openPointFromList(point) {
            const map = this.$refs.myMap?.mapObject;
            const lat = Number(point?.lat);
            const long = Number(point?.long);

            if (map && Number.isFinite(lat) && Number.isFinite(long)) {
                const targetZoom = 11;
                map.setView([lat, long], targetZoom, { animate: true });
                setTimeout(() => this.openPointTooltip(point.id), 280);
            } else {
                this.openPointTooltip(point.id);
            }

            this.selectedPoint = point;
        },
        openPointTooltip(pointId) {
            const markerRefs = Array.isArray(this.$refs.pointMarkers)
                ? this.$refs.pointMarkers
                : [this.$refs.pointMarkers].filter(Boolean);
            if (markerRefs.length === 0) return;

            for (const markerRef of markerRefs) {
                markerRef?.mapObject?.closeTooltip?.();
            }

            const targetMarker = markerRefs.find(
                markerRef => Number(markerRef?.mapObject?.options?.pointId) === Number(pointId)
            );
            targetMarker?.mapObject?.openTooltip?.();
        },
        getDefaultLayer(listLayer) {
            let list = [];
            for (const item of listLayer) {
                if (item.children && item.children.length > 0) {
                    list = list.concat(this.getDefaultLayer(item.children));
                } else {
                    if (item.defaultShow) list.push(item);
                }
            }
            return list;
        },
        createRasterColorFn(legend = []) {
            return values => {
                const pixelValue = values[0];
                if (!Number.isFinite(pixelValue) || pixelValue < 0) return null;
                for (const item of legend) {
                    if (pixelValue <= Number(item.value)) return item.color;
                }
                return '#000000';
            };
        },
        async upsertRasterLayer(file) {
            const map = this.$refs.myMap.mapObject;
            const georaster = await parseGeoraster(
                `${API_CONFIG.BASE_URL}map-layer/${this.rasterInfo.id}/download-file?fileName=${file}`
            );
            const pixelValuesToColorFn = this.createRasterColorFn(this.rasterInfo.legend ?? []);

            if (this.rasterLayer) {
                this.rasterLayer.updateData({
                    georaster,
                    pixelValuesToColorFn,
                });
                if (!map.hasLayer(this.rasterLayer)) this.rasterLayer.addTo(map);
                return;
            }

            if (this.rasterLayer) map.removeLayer(this.rasterLayer);
            this.rasterLayer = new GeoRasterLayer({
                georaster,
                caching: false,
                opacity: 0.7,
                resolution: 256,
                zIndex: 600,
                resampleMethod: "nearest",
                pixelValuesToColorFn
            });
            this.rasterLayer.addTo(map);
        },
        async onTimeChange(file) {
            if (!this.rasterInfo?.id || !file) return;
            await this.upsertRasterLayer(file);
        },
        handleMapClickRaster(event) {
            const map = this.$refs.myMap?.mapObject;
            if (!map || !this.rasterLayer || !map.hasLayer(this.rasterLayer)) return;
            if (!this.rasterLayer.getBounds?.().contains(event.latlng)) return;
            if (!this.rasterInfo?.id) return;

            const lat = event.latlng.lat;
            const lng = event.latlng.lng;

            this.showRasterDetailModal = true;
            this.selectedPointDetail = {
                id: this.rasterInfo.id,
                lat,
                lng,
                legend: this.rasterInfo.legend,
                chartType: this.rasterInfo.chartType
            };
        },
        handleClickOutside(event) {
            if (!this.showLeftSide) return;
            const leftSidePanel = this.$refs.leftSidePanel;
            if (leftSidePanel && !leftSidePanel.contains(event.target)) {
                this.showLeftSide = false;
            }
        }
    }
};
</script>
<style lang="scss">
.leaflet-popup-content {
    text-align: center !important;
    width: unset !important;
}

.leaflet-marker-photo b {
    height: 16px !important;
    min-width: 16px !important;
}

.station-bg {
    margin-left: -12px !important;
    margin-top: -12px !important;
    width: 32px !important;
    height: 32px !important;
    z-index: 302 !important;
    background-clip: padding-box;
    border-radius: 20px;

    div {
        width: 24px;
        height: 24px;
        margin-left: 4px;
        margin-top: 4px;
        text-align: center;
        border-radius: 15px;
        font-weight: 700;
        color: #fff;
        display: inline-block;
    }

    span {
        line-height: 24px;
    }
}

.geojson-type {
    color: black;
    margin-right: 0px !important;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);

    .nav-link {
        padding: 0.5rem 0.85rem !important;
        color: black;
    }

    button {
        padding: 0.45rem !important;
    }
}

.leaflet-control-search {
    .search-input {
        min-width: 150px;
    }
}

.station-modal {
    .modal-content {
        border-radius: 10px;

        .modal-body {
            padding: 0.5rem;
        }
    }
}

.photo-img {
    width: 200px;
    height: auto;
}

@media screen and (max-width: 500px) {
    .station-modal {
        .modal-dialog {
            margin: 1.75rem;
        }
    }

    .btn-label {
        display: none;
    }

    .photo-img {
        max-width: 30%;
        height: auto;
    }
}

.detail-card {
    border-radius: 10px;

    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.history-card {
    border-radius: 10px;
    margin-bottom: 0;

    .card-header {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
}

.region-label {
    font-size: 14px;
    z-index: 400 !important;
    height: auto !important;
    width: 90px !important;
}

.leaflet-tooltip.point-label {
    color: orange;
}

.geojson-table {

    th,
    td {
        padding: 4px;
        text-align: left;
    }
}

.summary-treeselect {

    .vue-treeselect__multi-value-item-container,
    .vue-treeselect__limit-tip {
        display: none;
    }

    &.vue-treeselect--has-value .vue-treeselect__placeholder.vue-treeselect-helper-hide {
        display: block !important;
    }
}

.point-list-panel {
    position: absolute;
    right: 10px;
    z-index: 1000;
    width: 220px;
    max-width: calc(100vw - 20px);
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid #cfd8e3;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
    backdrop-filter: blur(1px);
}

.point-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 12px;
    background: linear-gradient(90deg, #eaf4ff, #f7fbff);
    border-bottom: 1px solid #d9e4f2;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.point-list-title {
    font-weight: 700;
    color: #1f2937;
}

.point-list-count {
    min-width: 28px;
    height: 24px;
    padding: 0 8px;
    border-radius: 20px;
    background: #1976d2;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.point-list-table-wrap {
    max-height: 320px;
    overflow: auto;
}

.point-list-table th,
.point-list-table td {
    padding: 7px 8px;
    border-top: 1px solid #edf2f7;
    vertical-align: middle;
}

.point-list-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f8fbff;
    color: #4b5563;
    font-weight: 600;
    font-size: 12px;
    border-top: none;
    text-transform: uppercase;
}

.point-list-table th:first-child,
.point-list-table td:first-child {
    width: 52px;
    text-align: center;
}

.point-list-row {
    cursor: pointer;
    transition: background-color 0.16s ease;
}

.point-list-row:hover {
    background-color: #eef6ff;
}

.point-list-row.active {
    background-color: #dbeafe;
}

@media screen and (max-width: 500px) {
    .point-list-panel {
        width: calc(100vw - 20px);
    }
}
</style>
